import { Field, FormikErrors, FormikValues } from "formik";

interface GeneralTermsFieldsProps {
  values: FormikValues;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean
  ) => Promise<void | FormikErrors<FormikValues>>;
  handleChange: (e: React.ChangeEvent<any>) => void;
  generalTermsList: any[];
}

const GeneralTermsFields: React.FC<GeneralTermsFieldsProps> = ({
  values,
  setFieldValue,
  handleChange,
  generalTermsList,
}) => {
  const isAllSelected =
    generalTermsList.length > 0 &&
    values.general_terms?.length === generalTermsList.length;

  const handleCheckBoxChange = (e: any, termId: any) => {
    handleChange(e);

    const isChecked = e.target.checked;
    let updatedCheck: any[] = [...(values.general_terms || [])];

    if (isChecked) {
      updatedCheck = [...updatedCheck, termId];
    } else {
      updatedCheck = updatedCheck.filter((item: any) => item !== termId);
    }

    setFieldValue("general_terms", updatedCheck);
  };

  const handleSelectAllChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      const updatedCheckAll = generalTermsList.map((item: any) => item.id);
      setFieldValue("general_terms", updatedCheckAll);
    } else {
      setFieldValue("general_terms", []);
    }
  };

  return (
    <div className="card my-card">
      <div className="card-header my-card-header bg-lighter d-flex justify-content-between">
        <h6 className="my-card-header-head">General Terms</h6>
        <div className="my-card-header-checkbox m-2 mb-0">
          <Field
            type="checkbox"
            name="All_general_terms"
            className="form-check-input me-2"
            checked={isAllSelected}
            onChange={(e: any) => handleSelectAllChange(e)}
          />
          <label className="form-check-label">Select All</label>
        </div>
      </div>
      <div className="card-body my-card-body">
        <div className="row g-3 m-0">
          {Array.isArray(generalTermsList) && generalTermsList.length > 0 ? (
            generalTermsList.map((term: any) => (
              <div key={term?.id} className="col-12 col-lg-8 col-lg-4">
                <Field
                  type="checkbox"
                  name="general_terms"
                  value={term?.id}
                  className="form-check-input me-2"
                  id={term?.id}
                  checked={values?.general_terms?.includes(term?.id) || false}
                  onChange={(e: any) => handleCheckBoxChange(e, term.id)}
                />
                <label htmlFor={term?.id} className="form-check-label">
                  {term?.term || "No Name Found"}
                </label>
              </div>
            ))
          ) : (
            <p className="text-muted">
              No general terms available for the selected product.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default GeneralTermsFields;
